import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        style: {
            fill: "none"
        }
    }, props), {
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M7.63314 9.05866C7.5498 9.05033 7.4498 9.05033 7.35814 9.05866C5.3748 8.99199 3.7998 7.36699 3.7998 5.36699C3.7998 3.32533 5.4498 1.66699 7.4998 1.66699C9.54147 1.66699 11.1998 3.32533 11.1998 5.36699C11.1915 7.36699 9.61647 8.99199 7.63314 9.05866Z",
                stroke: "#777E91",
                "stroke-width": "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.6747 3.33301C15.2914 3.33301 16.5914 4.64134 16.5914 6.24967C16.5914 7.82467 15.3414 9.10801 13.7831 9.16634C13.7164 9.15801 13.6414 9.15801 13.5664 9.16634",
                stroke: "#777E91",
                "stroke-width": "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M3.4666 12.133C1.44993 13.483 1.44993 15.683 3.4666 17.0247C5.75827 18.558 9.5166 18.558 11.8083 17.0247C13.8249 15.6747 13.8249 13.4747 11.8083 12.133C9.52494 10.608 5.7666 10.608 3.4666 12.133Z",
                stroke: "#777E91",
                "stroke-width": "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M15.2832 16.667C15.8832 16.542 16.4499 16.3003 16.9165 15.942C18.2165 14.967 18.2165 13.3587 16.9165 12.3837C16.4582 12.0337 15.8999 11.8003 15.3082 11.667",
                stroke: "#777E91",
                "stroke-width": "1.5",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
export default Icon;
